module.exports = __webpack_public_path__ + "static/media/premium_wine_cake.9a033f67.jpg";